import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import DynamicTable from '../../DynamicTable';
import { useHasFilter } from '../../../../helpers/useHasFilter';
import { readableNumberParts } from '../../../../helpers/Numbers';
import DossierTableNoResult from './DossierTableNoResult';
import { visitInertia } from '../../../../helpers/Navigation';
const DossierTable = ({ dossiers, filters, loading }) => {
    const { hasFilter } = useHasFilter(filters);
    const { t } = useTranslation();
    return (_jsx(DynamicTable, { id: "dossiers", data: dossiers, loading: loading, onRowClick: (dossier, event) => visitInertia(`/dossier/${dossier.id}`, event, true), noData: () => _jsx(DossierTableNoResult, { filters: filters }), config: [
            {
                property: 'id',
                columnName: 'dossier.number_abbr',
                align: 'left',
                visible: true,
            },
            {
                property: 'debtor_name',
                columnName: 'dossier.debtor',
                align: 'left',
                visible: true,
            },
            {
                property: 'opened_at',
                columnName: 'dossier.start_date',
                align: 'left',
                visible: true,
                noWrap: true,
                transform: value => typeof value === 'string'
                    ? new Date(value).toLocaleDateString('nl-nl', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })
                    : value,
            },
            {
                property: 'outstanding_amount',
                columnName: 'dossier.balance',
                align: 'left',
                visible: true,
                transform: value => typeof value === 'number'
                    ? readableNumberParts(value, 'EUR').long
                    : value,
            },
            {
                property: 'reference',
                columnName: 'dossier.reference',
                align: 'left',
                visible: true,
            },
            {
                property: 'license_plate',
                columnName: 'dossier.license_plate',
                align: 'left',
                when: () => hasFilter('license_plate'),
            },
            {
                property: 'bsn',
                columnName: 'dossier.bsn',
                align: 'left',
                when: () => hasFilter('bsn'),
                transform: () => filters.bsn,
            },
            {
                property: 'kvk',
                columnName: 'dossier.kvk',
                align: 'left',
                when: () => hasFilter('kvk'),
                transform: () => filters.kvk,
            },
            {
                property: 'phase',
                columnName: 'dossier.phase',
                align: 'left',
                visible: true,
                transform: (phase) => phase?.name,
            },
            {
                property: 'status',
                columnName: 'dossier.status',
                align: 'left',
                visible: true,
            },
            {
                property: 'duration',
                columnName: 'dossier.duration',
                align: 'left',
                visible: true,
            },
            {
                property: 'objection_status',
                columnName: 'dossier.objection_status',
                align: 'left',
                when: () => hasFilter('objection_status'),
                transform: objection_status => typeof objection_status === 'string'
                    ? t(`objection_status.${objection_status}`)
                    : null,
            },
        ] }));
};
export default DossierTable;
